import React from 'react'
import './index.scss'

/**
 * @param {React.ReactElement} children - Component content
 * @param {Boolean} selected - Defines if chip is selected
 * @param {Boolean} disabled - If true, the chip will be disabled
 * @param {String} selectedColor - Defines chip color
 *
 * @returns {React.ReactElement}
 */

function Chip({ children = "", selected = false, disabled = false, selectedColor = "green", ...props }) {

  function setClassName() {
    let className = "chip"
    if (selected) className += ` chip--selected chip--selected--${selectedColor}`
    if (disabled) className += " chip--disabled"
    return className
  }

  return (
    <div className={setClassName()} disabled={disabled} {...props}>
      {children}
    </div>
  )
}

export default Chip
